const projectConf = require("../../project.config.js");

module.exports = {
    host: "",
    imgHost: "",
};
